(function () {
  /**
   * This module is part of a migration path from PHP-based eSM to the client-side app. Currently, it simply exposes
   * logout for use by the sessionmanager.
   */

  var module = namespace.create('leica.pi.auth');
  var global = namespace.using('leica.pi.global');
  var windowManager = {
    _cw: null,
    get childWindows () {
      if (!windowManager._cw) {
        var value = localStorage.getItem('childWindows');
        if (value) {
          value = JSON.parse(value);
        } else {
          value = [];
        }
        windowManager._cw = value;
      }
      return windowManager._cw;
    },
    add: function (value) {
      if (!windowManager.childWindows.includes(value)) {
        windowManager.childWindows.push(value);
        localStorage.setItem('childWindows', JSON.stringify(windowManager.childWindows));
      }
    },
    clear: function () {
      windowManager.childWindows.splice(0);
      localStorage.setItem('childWindows', JSON.stringify(windowManager.childWindows));
    }
  };

  var isChildWindow = Boolean(window.name && window.opener && (window.opener !== window));

  module.consts = {
    SESSION_TIMEOUT: 'Session Timeout'
  };

  module.logoff = function (message) {
    global.events.trigger('before-logoff');

    var logoffPage = '/Auth/LogOff.php?';

    // If we're a child window (e.g. webviewer), try to close ourselves instead of having two tabs at the logoff screen.
    if (isChildWindow) { // if parent window is closed opener gets reassigned to... self?
      // first try closing ourself
      window.close();
      // if that fails, ask the parent to close us
      var endChildSession = window._.get(window, 'opener.leica.pi.auth.endChildSession');
      if (endChildSession) {
        module.endChildSession(window);
      }
      // ...and if that fails we're out of options so just log off normally.
    } else { // If we're eSM and we have child windows, then close them
      closeChildWindows();
    }

    if (message === module.consts.SESSION_TIMEOUT) {
      logoffPage += 'timeout=true';
    } else {
      logoffPage += 'message=' + message;
    }
    window.location = logoffPage;
  }

  /**
   * Child window Management
   * **/

  // expose a hook that allows child windows to be closed when their session expires.
  module.endChildSession = function endChildSession (child) {
    if (child) {
      child.close();
    }
  };

  // Function to allow us to close all registered child windows.
  function closeChildWindows () {
    if (isChildWindow) {
      module.logoff();
    } else {
      var names = windowManager.childWindows;
      if (names) {
        names.forEach(function (name) {
          var child = window.open('', name);
          module.endChildSession(child);
        });
        windowManager.clear();
      }
    }
  }

  // If we are a child window, register ourselves in a shared cache
  if (isChildWindow) {
    windowManager.add(window.name);
  }

  // On logoff, close all child windows.
  $(function () {
    $('#LogoffBtn').on('click', function () {
      if (isChildWindow) {
        window.opener.namespace('leica.pi.auth')
        var parentAuth = window.opener.namespace('leica.pi.auth');
        if (parentAuth.logoff) {
          parentAuth.logoff();
        }
      } else {
        closeChildWindows();
      }
    });
  });
}());
